(function() {
  'use strict';

  function initGallery(gallery) {
    var dots = Array.prototype.slice.call(gallery.querySelectorAll('.sexlovey-gallery-dot'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.product-single__thumbnail-item'));

    if (!dots.length || !thumbs.length) {
      return;
    }

    function syncDots() {
      var activeThumb = gallery.querySelector('.product-single__thumbnail-item.is-active');
      var activeId = activeThumb ? String(activeThumb.getAttribute('data-image-id')) : '';

      dots.forEach(function(dot) {
        var active = String(dot.getAttribute('data-image-id')) === activeId;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });

      Array.prototype.forEach.call(
        gallery.querySelectorAll('.product__photo-container video'),
        function(video) {
          var container = video.closest('.product__photo-container');
          var mediaId = container ? String(container.getAttribute('data-image-id')) : '';

          if (mediaId !== activeId && !video.paused) {
            video.pause();
          }
        }
      );
    }

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        var imageId = String(dot.getAttribute('data-image-id'));
        var thumb = gallery.querySelector('.product-single__thumbnail-item[data-image-id="' + imageId + '"] .product-single__thumbnail');

        if (thumb) {
          thumb.click();
        }
      });
    });

    thumbs.forEach(function(thumb) {
      new MutationObserver(syncDots).observe(thumb, {
        attributes: true,
        attributeFilter: ['class']
      });
    });

    syncDots();
  }

  function htmlToText(value) {
    var parser = document.createElement('div');
    parser.innerHTML = value || '';
    return (parser.textContent || parser.innerText || '').trim();
  }

  function formatSavingsAmount(amount, moneyFormat) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && moneyFormat) {
      return htmlToText(window.Shopify.formatMoney(amount, moneyFormat));
    }

    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: amount % 100 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    }).format(amount / 100);
  }

  function initSavings(container) {
    var item = container.querySelector('[data-sexlovey-save]');
    var value = item ? item.querySelector('.sexlovey-product-save') : null;

    if (!item || !value || !window.jQuery) {
      return;
    }

    var label = item.getAttribute('data-save-label') || 'Save [percent]% · [amount] off';
    var moneyFormat = item.getAttribute('data-money-format');
    var $container = window.jQuery(container);

    $container
      .off('variantPriceChange.sexloveySavings')
      .on('variantPriceChange.sexloveySavings', function(event) {
        var variant = event.variant;

        if (!variant || !variant.compare_at_price || variant.compare_at_price <= variant.price) {
          item.classList.add('hide');
          return;
        }

        var amount = variant.compare_at_price - variant.price;
        var percentage = Math.round(amount * 100 / variant.compare_at_price);
        var amountText = formatSavingsAmount(amount, moneyFormat);

        value.textContent = label
          .replace('[percent]', percentage)
          .replace('[amount]', amountText);
        item.classList.remove('hide');
      });
  }

  function initProductTabs(container) {
    if (container.getAttribute('data-sexlovey-tabs-initialized') === 'true') {
      return;
    }

    var tabs = Array.prototype.slice.call(container.querySelectorAll('[data-sexlovey-tab]'));
    var accordionButtons = Array.prototype.slice.call(container.querySelectorAll('[data-sexlovey-accordion]'));
    var panels = Array.prototype.slice.call(container.querySelectorAll('[data-sexlovey-panel]'));
    var mobileMedia = window.matchMedia('(max-width: 749px)');
    var mobileReviewsAutoExpanded = false;
    var mobileReviewsObserver = null;

    if (!tabs.length || !accordionButtons.length || !panels.length) {
      return;
    }

    container.setAttribute('data-sexlovey-tabs-initialized', 'true');

    function getAccordionButton(name) {
      return accordionButtons.find(function(button) {
        return button.getAttribute('data-sexlovey-accordion') === name;
      });
    }

    function getPanel(name) {
      return panels.find(function(panel) {
        return panel.getAttribute('data-sexlovey-panel') === name;
      });
    }

    function setMobileButtonState(name, open) {
      var button = getAccordionButton(name);

      if (!button) {
        return;
      }

      button.classList.toggle('is-active', open);
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function setMobilePanelState(name, open) {
      var panel = getPanel(name);

      if (!panel) {
        return;
      }

      panel.classList.toggle('is-active', open);
      panel.hidden = !open;
      setMobileButtonState(name, open);
    }

    function selectDesktopTab(name, shouldScroll, shouldFocus) {
      tabs.forEach(function(tab) {
        var active = tab.getAttribute('data-sexlovey-tab') === name;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');

        if (active && shouldFocus) {
          tab.focus();
        }
      });

      panels.forEach(function(panel) {
        var active = panel.getAttribute('data-sexlovey-panel') === name;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });

      if (shouldScroll) {
        window.requestAnimationFrame(function() {
          container.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }

      if (name === 'reviews') {
        window.setTimeout(function() {
          window.dispatchEvent(new Event('resize'));
        }, 100);
      }
    }

    function toggleMobileAccordion(name, forceOpen, shouldScroll, sourceButton) {
      var button = getAccordionButton(name);
      var currentlyOpen = button && button.getAttribute('aria-expanded') === 'true';
      var open = typeof forceOpen === 'boolean' ? forceOpen : !currentlyOpen;
      var preserveTop = null;

      if (sourceButton) {
        preserveTop = sourceButton.getBoundingClientRect().top;
      }

      if (name === 'description') {
        setMobilePanelState('description', open);
      } else {
        if (open) {
          ['reviews', 'why', 'faq'].forEach(function(otherName) {
            if (otherName !== name) {
              setMobilePanelState(otherName, false);
            }
          });
        }

        setMobilePanelState(name, open);
      }

      if (sourceButton && preserveTop !== null) {
        window.requestAnimationFrame(function() {
          var newTop = sourceButton.getBoundingClientRect().top;
          window.scrollBy(0, newTop - preserveTop);
        });
      } else if (shouldScroll) {
        window.requestAnimationFrame(function() {
          var target = getAccordionButton(name);

          if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      }

      if (name === 'reviews' && open) {
        window.setTimeout(function() {
          window.dispatchEvent(new Event('resize'));
        }, 100);
      }
    }

    function resetMobileAccordion() {
      setMobilePanelState('description', true);
      setMobilePanelState('reviews', false);
      setMobilePanelState('why', false);
      setMobilePanelState('faq', false);
    }

    // Auto-open Reviews once as the mobile visitor finishes the Description.
    // Use the existing accordion controller to keep the icon, ARIA state and
    // Ryviu resize handling aligned. Never force-scroll or override later taps.
    function stopMobileReviewAutoExpand() {
      if (mobileReviewsObserver) {
        mobileReviewsObserver.disconnect();
        mobileReviewsObserver = null;
      }
    }

    function startMobileReviewAutoExpand() {
      stopMobileReviewAutoExpand();

      if (!mobileMedia.matches || mobileReviewsAutoExpanded) {
        return;
      }

      var reviewButton = getAccordionButton('reviews');

      if (!reviewButton || typeof window.IntersectionObserver !== 'function') {
        return;
      }

      mobileReviewsObserver = new IntersectionObserver(function(entries) {
        var reachedReviews = entries.some(function(entry) {
          return entry.target === reviewButton && entry.isIntersecting;
        });

        if (!reachedReviews || !mobileMedia.matches || mobileReviewsAutoExpanded) {
          return;
        }

        mobileReviewsAutoExpanded = true;
        stopMobileReviewAutoExpand();

        if (reviewButton.getAttribute('aria-expanded') !== 'true') {
          toggleMobileAccordion('reviews', true, false, null);
        }
      }, {
        root: null,
        rootMargin: '0px 0px -12% 0px',
        threshold: 0
      });

      mobileReviewsObserver.observe(reviewButton);
    }

    tabs.forEach(function(tab, index) {
      tab.addEventListener('click', function() {
        if (!mobileMedia.matches) {
          selectDesktopTab(tab.getAttribute('data-sexlovey-tab'), false, false);
        }
      });

      tab.addEventListener('keydown', function(event) {
        if (mobileMedia.matches) {
          return;
        }

        var nextIndex = index;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          nextIndex = (index + 1) % tabs.length;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          nextIndex = (index - 1 + tabs.length) % tabs.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = tabs.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        selectDesktopTab(tabs[nextIndex].getAttribute('data-sexlovey-tab'), false, true);
      });
    });

    accordionButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        if (!mobileMedia.matches) {
          return;
        }

        var name = button.getAttribute('data-sexlovey-accordion');

        if (name === 'reviews') {
          mobileReviewsAutoExpanded = true;
          stopMobileReviewAutoExpand();
        }

        toggleMobileAccordion(name, null, false, button);
      });
    });

    var productSection = container.closest('[data-section-type="product"]');
    var reviewSummary = productSection ? productSection.querySelector('.review-widget') : null;

    function openReviews(shouldScroll) {
      if (mobileMedia.matches) {
        mobileReviewsAutoExpanded = true;
        stopMobileReviewAutoExpand();
        toggleMobileAccordion('reviews', true, shouldScroll, null);
      } else {
        selectDesktopTab('reviews', shouldScroll, false);
      }
    }

    if (reviewSummary) {
      reviewSummary.addEventListener('click', function(event) {
        event.preventDefault();
        openReviews(true);
      }, true);
    }

    function openReviewsFromHash() {
      if (window.location.hash === '#reviews' || window.location.hash === '#ryviu-widget') {
        openReviews(true);
      }
    }

    function syncMode() {
      stopMobileReviewAutoExpand();

      if (mobileMedia.matches) {
        resetMobileAccordion();
      } else {
        selectDesktopTab('description', false, false);
      }

      openReviewsFromHash();

      if (mobileMedia.matches) {
        startMobileReviewAutoExpand();
      }
    }

    if (mobileMedia.addEventListener) {
      mobileMedia.addEventListener('change', syncMode);
    } else if (mobileMedia.addListener) {
      mobileMedia.addListener(syncMode);
    }

    syncMode();
    window.addEventListener('hashchange', openReviewsFromHash);
  }

  function initStickyCart(bar) {
    if (bar.getAttribute('data-sexlovey-sticky-initialized') === 'true') {
      return;
    }

    var formId = bar.getAttribute('data-product-form-id');
    var form = formId ? document.getElementById(formId) : null;
    var section = form ? form.closest('[data-section-type="product"]') : null;
    var stickyPrice = bar.querySelector('.sexlovey-sticky-cart__price');
    var stickyButton = bar.querySelector('.sexlovey-sticky-cart__button');
    var stickyOptions = bar.querySelectorAll('[data-sexlovey-sticky-option]');
    var ticking = false;
    var googleWidget = null;
    var googleWidgetSyncQueued = false;
    var googleWidgetOriginalBottom = new WeakMap();

    if (!form || !section || !stickyPrice || !stickyButton) {
      return;
    }

    bar.setAttribute('data-sexlovey-sticky-initialized', 'true');

    function getSourceButton() {
      return form.querySelector('[name="add"]');
    }

    function getSourcePrice() {
      return section.querySelector('[id^="ProductPrice-"]');
    }

    function getSourceOption(optionIndex) {
      return form.querySelector('.single-option-selector[data-index="' + optionIndex + '"]');
    }

    function hasGoogleWidgetSignal(element) {
      if (!element) {
        return false;
      }

      var className = typeof element.className === 'string' ? element.className : '';
      var signature = [
        element.id || '',
        className,
        element.getAttribute('aria-label') || '',
        element.getAttribute('title') || '',
        element.tagName || ''
      ].join(' ').toLowerCase();

      if (/merchant|store[-_ ]?widget|store quality|ratingbadge|google[-_ ]?store|gts[-_]/.test(signature)) {
        return true;
      }

      var frame = element.tagName === 'IFRAME' ? element : element.querySelector('iframe');

      if (frame) {
        var frameSignature = [
          frame.getAttribute('src') || '',
          frame.getAttribute('title') || '',
          frame.getAttribute('aria-label') || ''
        ].join(' ').toLowerCase();

        if (/(google|gstatic)/.test(frameSignature) && /(shop|merchant|store|rating)/.test(frameSignature)) {
          return true;
        }
      }

      if (element.shadowRoot) {
        var shadowSignature = [
          element.shadowRoot.textContent || '',
          element.shadowRoot.innerHTML || ''
        ].join(' ').toLowerCase();

        if (/(store quality|merchant|ratingbadge|google store)/.test(shadowSignature)) {
          return true;
        }
      }

      return false;
    }

    function getFixedContainer(element) {
      var current = element;

      while (current && current !== document.body && current !== document.documentElement) {
        if (window.getComputedStyle(current).position === 'fixed') {
          return current;
        }

        current = current.parentElement;
      }

      return null;
    }

    function isExcludedFixedElement(element) {
      var chatSelector = [
        '#shopify-chat',
        '.shopify-chat',
        '[data-shopify-chat]',
        '#tidio-chat',
        '#chatra',
        '.chatra',
        '#gorgias-chat-container',
        'iframe[title*="chat" i]'
      ].join(',');

      return element === bar ||
        bar.contains(element) ||
        element.contains(bar) ||
        element.matches(chatSelector) ||
        Boolean(element.closest(chatSelector));
    }

    function getGoogleWidgetCandidate(element, allowConfiguredPosition) {
      var fixedElement = getFixedContainer(element);

      if (!fixedElement || isExcludedFixedElement(fixedElement)) {
        return null;
      }

      var style = window.getComputedStyle(fixedElement);
      var rect = fixedElement.getBoundingClientRect();
      var bottomGap = window.innerHeight - rect.bottom;

      if (
        style.display === 'none' ||
        style.visibility === 'hidden' ||
        rect.width < 36 ||
        rect.width > 220 ||
        rect.height < 36 ||
        rect.height > 220 ||
        rect.left < -20 ||
        rect.left > 100 ||
        bottomGap < -20 ||
        bottomGap > 150
      ) {
        return null;
      }

      if (hasGoogleWidgetSignal(element) || hasGoogleWidgetSignal(fixedElement)) {
        return fixedElement;
      }

      var configuredBottom = parseFloat(style.bottom);
      var matchesConfiguredPosition = allowConfiguredPosition &&
        Number.isFinite(configuredBottom) &&
        Math.abs(rect.left - 16) <= 48 &&
        Math.abs(configuredBottom - 46) <= 36;

      return matchesConfiguredPosition ? fixedElement : null;
    }

    function findGoogleStoreWidget() {
      if (googleWidget && document.documentElement.contains(googleWidget)) {
        return googleWidget;
      }

      var explicitSelectors = [
        '[id*="merchant" i]',
        '[class*="merchant" i]',
        '[id*="store-widget" i]',
        '[class*="store-widget" i]',
        '[id*="store_widget" i]',
        '[class*="store_widget" i]',
        '[id*="ratingbadge" i]',
        '[class*="ratingbadge" i]',
        '[id*="gts" i]',
        '[class*="gts" i]',
        'iframe[src*="google" i]',
        'iframe[src*="gstatic" i]'
      ].join(',');
      var explicitElements = document.querySelectorAll(explicitSelectors);
      var candidate = null;

      Array.prototype.some.call(explicitElements, function(element) {
        candidate = getGoogleWidgetCandidate(element, false);
        return Boolean(candidate);
      });

      if (candidate) {
        return candidate;
      }

      var points = [
        [44, window.innerHeight - 74],
        [72, window.innerHeight - 74],
        [44, window.innerHeight - 104]
      ];

      points.some(function(point) {
        if (point[1] < 0) {
          return false;
        }

        return document.elementsFromPoint(point[0], point[1]).some(function(element) {
          candidate = getGoogleWidgetCandidate(element, true);
          return Boolean(candidate);
        });
      });

      return candidate;
    }

    function updateGoogleWidgetOffset(visible) {
      var widget = findGoogleStoreWidget();

      if (!widget) {
        return;
      }

      googleWidget = widget;
      widget.setAttribute('data-sexlovey-google-widget-offset', 'true');

      if (!googleWidgetOriginalBottom.has(widget)) {
        googleWidgetOriginalBottom.set(widget, {
          value: widget.style.getPropertyValue('bottom'),
          priority: widget.style.getPropertyPriority('bottom')
        });
      }

      if (visible) {
        widget.style.setProperty(
          'bottom',
          'calc(var(--sexlovey-sticky-cart-height, 68px) + 16px)',
          'important'
        );
        return;
      }

      var originalBottom = googleWidgetOriginalBottom.get(widget);

      if (originalBottom.value) {
        widget.style.setProperty('bottom', originalBottom.value, originalBottom.priority);
      } else {
        widget.style.removeProperty('bottom');
      }
    }

    function requestGoogleWidgetSync() {
      if (googleWidgetSyncQueued) {
        return;
      }

      googleWidgetSyncQueued = true;
      window.requestAnimationFrame(function() {
        updateGoogleWidgetOffset(document.body.classList.contains('sexlovey-sticky-cart-visible'));
        googleWidgetSyncQueued = false;
      });
    }

    function syncOptions() {
      Array.prototype.forEach.call(stickyOptions, function(stickyOption) {
        var optionIndex = stickyOption.getAttribute('data-option-index');
        var sourceOption = getSourceOption(optionIndex);

        if (sourceOption && stickyOption.value !== sourceOption.value) {
          stickyOption.value = sourceOption.value;
        }

        stickyOption.disabled = !sourceOption || sourceOption.disabled;
      });
    }

    function updateStickyHeight() {
      if (!window.matchMedia('(max-width: 749px)').matches) {
        return;
      }

      document.documentElement.style.setProperty(
        '--sexlovey-sticky-cart-height',
        Math.ceil(bar.getBoundingClientRect().height) + 'px'
      );
    }

    function updateVisibility() {
      var sourceButton = getSourceButton();
      var mobile = window.matchMedia('(max-width: 749px)').matches;
      var visible = mobile && sourceButton && sourceButton.getBoundingClientRect().bottom < 0;

      bar.classList.toggle('is-visible', Boolean(visible));
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      bar.inert = !visible;
      document.body.classList.toggle('sexlovey-sticky-cart-visible', Boolean(visible));

      if (visible) {
        updateStickyHeight();
      }

      updateGoogleWidgetOffset(Boolean(visible));
    }

    function syncState() {
      var sourceButton = getSourceButton();
      var sourcePrice = getSourcePrice();

      syncOptions();

      if (sourcePrice) {
        stickyPrice.textContent = sourcePrice.textContent.trim();
      }

      if (sourceButton) {
        stickyButton.disabled = sourceButton.disabled;
        stickyButton.textContent = sourceButton.textContent.trim();
      }

      updateVisibility();
    }

    function delayedSync() {
      window.setTimeout(syncState, 0);
      window.setTimeout(syncState, 80);
    }

    function requestVisibilityUpdate() {
      if (ticking) {
        return;
      }

      ticking = true;
      window.requestAnimationFrame(function() {
        updateVisibility();
        ticking = false;
      });
    }

    Array.prototype.forEach.call(stickyOptions, function(stickyOption) {
      stickyOption.addEventListener('change', function() {
        var sourceOption = getSourceOption(stickyOption.getAttribute('data-option-index'));

        if (!sourceOption || sourceOption.value === stickyOption.value) {
          syncState();
          return;
        }

        sourceOption.value = stickyOption.value;
        sourceOption.dispatchEvent(new Event('change', { bubbles: true }));
        delayedSync();
      });
    });

    stickyButton.addEventListener('click', function() {
      var sourceButton = getSourceButton();

      if (!sourceButton || sourceButton.disabled) {
        return;
      }

      sourceButton.click();
      delayedSync();
    });

    section.addEventListener('change', delayedSync);

    window.addEventListener('scroll', requestVisibilityUpdate, { passive: true });
    window.addEventListener('resize', function() {
      updateStickyHeight();
      requestVisibilityUpdate();
    });

    new MutationObserver(delayedSync).observe(form, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['disabled', 'class']
    });

    new MutationObserver(requestGoogleWidgetSync).observe(document.body, {
      childList: true,
      subtree: true
    });

    var sourcePrice = getSourcePrice();

    if (sourcePrice) {
      new MutationObserver(delayedSync).observe(sourcePrice, {
        attributes: true,
        childList: true,
        subtree: true
      });
    }

    if (window.jQuery) {
      window.jQuery(section)
        .off('variantPriceChange.sexloveyStickyCart')
        .on('variantPriceChange.sexloveyStickyCart', delayedSync);
    }

    syncState();
    window.setTimeout(requestGoogleWidgetSync, 500);
    window.setTimeout(requestGoogleWidgetSync, 1500);
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sexlovey-gallery]'), initGallery);
    Array.prototype.forEach.call(document.querySelectorAll('[data-section-type="product"]'), initSavings);
    Array.prototype.forEach.call(document.querySelectorAll('[data-sexlovey-product-tabs]'), initProductTabs);
    Array.prototype.forEach.call(document.querySelectorAll('[data-sexlovey-sticky-cart]'), initStickyCart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


(function() {
  var isIOSChrome = /CriOS/i.test(navigator.userAgent);

  if (!isIOSChrome) {
    return;
  }

  var root = document.documentElement;
  var minViewportHeight = null;
  var frameRequested = false;

  function hasFocusedEditor() {
    var active = document.activeElement;

    if (!active) {
      return false;
    }

    return /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName) || active.isContentEditable;
  }

  function getViewportHeight() {
    return window.visualViewport ? window.visualViewport.height : window.innerHeight;
  }

  function syncChromeViewport() {
    frameRequested = false;

    if (hasFocusedEditor()) {
      return;
    }

    if (window.visualViewport && window.visualViewport.scale !== 1) {
      return;
    }

    var viewportHeight = getViewportHeight();

    if (!isFinite(viewportHeight)) {
      return;
    }

    if (minViewportHeight === null || viewportHeight < minViewportHeight) {
      minViewportHeight = viewportHeight;
    }

    var visualBottomGap = 0;

    if (window.visualViewport) {
      visualBottomGap = Math.max(
        0,
        Math.round(
          window.visualViewport.offsetTop +
          window.visualViewport.height -
          window.innerHeight
        )
      );
    }

    var toolbarHidden =
      visualBottomGap > 8 ||
      (minViewportHeight !== null && viewportHeight > minViewportHeight + 18);

    root.classList.toggle('sexlovey-ios-chrome-toolbar-hidden', toolbarHidden);
    root.style.setProperty(
      '--sexlovey-chrome-viewport-gap',
      visualBottomGap + 'px'
    );
  }

  function requestSync() {
    if (frameRequested) {
      return;
    }

    frameRequested = true;
    window.requestAnimationFrame(syncChromeViewport);
  }

  window.addEventListener('resize', requestSync, { passive: true });
  window.addEventListener('scroll', requestSync, { passive: true });

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', requestSync, { passive: true });
    window.visualViewport.addEventListener('scroll', requestSync, { passive: true });
  }

  window.addEventListener('orientationchange', function() {
    minViewportHeight = null;
    root.classList.remove('sexlovey-ios-chrome-toolbar-hidden');
    root.style.setProperty('--sexlovey-chrome-viewport-gap', '0px');
    window.setTimeout(requestSync, 250);
  });

  syncChromeViewport();
})();
